package com.ijoin.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue

@Composable
actual fun rememberMediaPicker(): MediaPickerState {
    var selectedFiles by remember { mutableStateOf<List<String>>(emptyList()) }
    
    return MediaPickerState(
        pickFiles = {
            // Create file input element using JavaScript
            val input = js("document.createElement('input')").unsafeCast<dynamic>()
            input.type = "file"
            input.accept = "image/*,video/*"
            input.multiple = true
            input.style.display = "none"
            
            input.onchange = { event: dynamic ->
                val files = event.target.files
                if (files != null) {
                    val fileList = mutableListOf<String>()
                    val fileCount = files.length.unsafeCast<Int>()
                    var loadedCount = 0
                    
                    for (i in 0 until fileCount) {
                        val file = files[i].unsafeCast<dynamic>()
                        val reader = js("new FileReader()").unsafeCast<dynamic>()
                        
                        reader.onload = { e: dynamic ->
                            val result = e.target.result.unsafeCast<String>()
                            fileList.add(result)
                            loadedCount++
                            if (loadedCount == fileCount) {
                                selectedFiles = fileList
                            }
                        }
                        
                        reader.readAsDataURL(file)
                    }
                }
                js("document.body.removeChild(input)")
            }
            
            js("document.body.appendChild(input)")
            input.click()
        },
        selectedFiles = selectedFiles
    )
}

